import React from "react";

/**
 * Shared Community Icons
 * Resource type icons used across the Communities feature
 */

export const IconGoogleSlide = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#FBBC04" {...props}>
    <path d="M6 2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm2 4h8v8H8V6zm0 10h8v2H8v-2z" />
  </svg>
);

export const IconGoogleDoc = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#4285F4" {...props}>
    <path d="M6 2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm2 4v12h8V6H8z" />
  </svg>
);

export const IconGoogleDrive = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#34A853" {...props}>
    <path d="M8 2l8 14H4l4-14zM2 16h20l-10 6-10-6z" />
  </svg>
);

export const IconPDF = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#DC2626" {...props}>
    <path d="M6 2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm2 4v12h8V6H8z" />
  </svg>
);

export const IconLink = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2" {...props}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

/**
 * Get icon component based on resource type
 * @param {string} type - Resource type
 * @returns {React.Element} Icon component
 */
export function getResourceIcon(type) {
  switch (type) {
    case "Google Slide":
      return <IconGoogleSlide />;
    case "Google Doc":
      return <IconGoogleDoc />;
    case "Google Drive":
      return <IconGoogleDrive />;
    case "PDF":
      return <IconPDF />;
    case "Link":
    default:
      return <IconLink />;
  }
}
